var React = require('react');

function NavIconsEdgeCompute (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#111a2b;}")),React.createElement("title",{"key":1},"nav-icons_edge-compute"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"d":"M28.56,57.12A28.56,28.56,0,1,0,0,28.56,28.56,28.56,0,0,0,28.56,57.12Zm0-53.91A25.35,25.35,0,1,1,3.21,28.56,25.35,25.35,0,0,1,28.56,3.21Z","key":0}),React.createElement("path",{"d":"M6.36,15.54H50.75L28.56,54Zm39.09,3.24H11.66L28.56,48Z","key":1})]))]);
}

NavIconsEdgeCompute.defaultProps = {"viewBox":"0 0 57.12 57.12"};

module.exports = NavIconsEdgeCompute;

NavIconsEdgeCompute.default = NavIconsEdgeCompute;
